// extracted by mini-css-extract-plugin
export var disabled = "_1f-a";
export var hierarchyLinkGray = "_1f-4";
export var hierarchyLinkUnderline = "_1f-3";
export var hierarchyPrimary = "_1f-0";
export var hierarchySecondary = "_1f-1";
export var hierarchyTertiary = "_1f-2";
export var pressed = "_1f-6";
export var themeAction = "_1f-5";
export var themeDestructive = "_1f-8";
export var themeNormal = "_1f-7";
export var themeSuccess = "_1f-9";